import _ from "lodash";

export const getResource = () => {
	const path = _.get(window, "location.pathname", "");
	const pathArray = path.substr(1).split("/") as Array<string>;
	const resource = _.first(pathArray)!.toUpperCase();
	return resource;
};
